
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as StatServices from "@/services/StatServices";
import * as FactcheckServices from "@/services/FactCheckService";

import { Partner, INTERACTION_TYPE_ARRAY } from "@/types";

@Component
export default class SocialInteractionsPerPartner extends Vue {
  @Prop({ required: true }) from!: Date;
  @Prop({ required: true }) to!: Date;

  partners = [] as Partner[];

  loading = true;

  requestedInteractionTypes = [
    "SOCIAL_CLICK",
    "FACEBOOK_CLICK_TROUGH",
    "TWITTER_CLICK_TROUGH",
  ];

  requestedInteractionTypesNames = [
    "Andere sociale media",
    "Facebook klik",
    "Twitter klik",
  ];

  data: Record<string, Array<{ tagId: string; count: number }>> = {};

  async fetchPartners() {
    this.partners = (await FactcheckServices.GetPartners()).filter(
      (e) => e.id !== "UNKNOWN"
    );
  }

  @Watch("from", { immediate: true })
  @Watch("to")
  async fetchInteractionsPerPartner() {
    this.loading = true;
    this.data = await StatServices.CountClicksPerShortLinkTagPerPartner(
      this.from,
      this.to
    );

    this.loading = false;
    this.$forceUpdate();
  }

  mounted() {
    this.fetchPartners();
    this.fetchInteractionsPerPartner();
  }
}
